import React from "react";
import { Search } from "lucide-react";

const SearchBox = ({
  value,
  onChange,
  onSearch,
  placeholder = "Search...",
}) => {
  return (
    <div
      className="relative flex items-center border border-gray-300 dark:border-acs-dark-border 
      bg-white dark:bg-acs-dark-surface rounded-full px-3 py-1.5 w-80
      focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500/20
      transition-none"
    >
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSearch();
        }}
        className="w-full pr-7 outline-none focus:outline-none focus:ring-0
          text-fluid-sm text-gray-800 dark:text-acs-dark-text
          placeholder-gray-400 dark:placeholder-acs-dark-subtext bg-transparent"
      />
      <button
        onClick={onSearch}
        className="absolute right-3 text-gray-500 dark:text-acs-dark-subtext
          hover:text-[#223688] dark:hover:text-acs-dark-hover transition-none"
      >
        <Search size={18} strokeWidth={2} />
      </button>
    </div>
  );
};

export default SearchBox;